import React, {createContext, useEffect, useState} from "react";

export const ToursContext = createContext();


export function ToursProvider(props) {

    const [accountTours, setAccountTours] = useState([]);
    const [activeTour, setActiveTour] = useState(null);

    return <ToursContext.Provider value={{ accountTours, setAccountTours, activeTour, setActiveTour }}>
            {props.children}
        </ToursContext.Provider>;

}
